import '@fortawesome/fontawesome-free/css/all.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const localeMessages = {};

const dateTimeFormats = {
	'en': {
		short: {
			year: 'numeric', month: 'short', day: 'numeric'
		},
		long: {
			year: 'numeric', month: 'short', day: 'numeric',
			weekday: 'short', hour: 'numeric', minute: 'numeric'
		}
	}
};

const i18n = new VueI18n({
	locale: 'fr',
	fallbackLocale: 'en',
	messages: localeMessages,
	dateTimeFormats
});

function loadVuetifyLocaleMessages (locales) {
	const messages = {};
	locales.forEach(locale => {
		if (locale !== 'en') {
			messages[locale] = require('../../node_modules/vuetify/lib/locale/' + locale).default;
		}
	});
	return messages;
}

Vue.use(Vuetify);

const vuetify = new Vuetify({
	iconfont: 'fa',
	lang: {
		locales: loadVuetifyLocaleMessages(Object.keys(localeMessages)),
		current: 'fr'
	}
});

export {
	i18n,
	vuetify
};
